// extracted by mini-css-extract-plugin
module.exports = {"CertificateCard":"CertificateCard_CertificateCard__1hsSe","CardContainer":"CertificateCard_CardContainer__wgx35","Certificates":"CertificateCard_Certificates__3VpRh"};